import { Dispatch, SetStateAction } from 'react';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, IconButton } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { AdobeJobStatus } from '@prisma/client';

import { SEPA_MANDATE_AGREEMENT_TABLE_TYPE } from 'src/utils/tableUtils';

import { RemindIdPayload } from '../../SepaAgreementTables.types';

export type SepaAgreementCallToActionsProps = {
    params: GridRenderCellParams;
    dataTestIdKey: string;
    handleViewRecord: (row: unknown) => void;
    setIsDeleteConfirmModalOpen: (value: SetStateAction<boolean>) => void;
    setIdToDelete: Dispatch<SetStateAction<number>>;
    setIsRemindConfirmModalOpen: (value: SetStateAction<boolean>) => void;
    setIdToRemind: Dispatch<RemindIdPayload>;
    agreementType: SEPA_MANDATE_AGREEMENT_TABLE_TYPE;
};

export function SepaAgreementCallToActions({
    params,
    dataTestIdKey,
    setIsDeleteConfirmModalOpen,
    setIdToDelete,
    handleViewRecord,
    setIsRemindConfirmModalOpen,
    setIdToRemind,
    agreementType,
}: SepaAgreementCallToActionsProps) {
    const {
        row: { id, status },
    } = params;

    const idToRemind = typeof id === 'string' ? Number(id) : id;

    return (
        <Box
            data-testid={`${dataTestIdKey}-dd-row-call-to-actions`}
            sx={{
                display: 'flex',
                height: '100%',
                justifyContent: 'flex-end',
                width: '100%',
            }}
        >
            {status !== AdobeJobStatus.SIGNED && (
                <IconButton
                    aria-label="remind"
                    hidden={status === AdobeJobStatus.SIGNED}
                    onClick={() => {
                        setIsRemindConfirmModalOpen(true);
                        setIdToRemind({
                            id: idToRemind,
                            agreementType,
                        });
                    }}
                >
                    <ReplayOutlinedIcon />
                </IconButton>
            )}

            {status !== AdobeJobStatus.OUT_FOR_SIGNATURE && (
                <IconButton
                    data-testid={`view-${dataTestIdKey}-dd-agreement-pdf-button`}
                    aria-label="view"
                    hidden={status === AdobeJobStatus.OUT_FOR_SIGNATURE}
                    onClick={() => {
                        handleViewRecord(params?.row);
                    }}
                >
                    <VisibilityOutlinedIcon />
                </IconButton>
            )}

            <IconButton
                data-testid={`delete-${dataTestIdKey}-dd-agreement-pdf-button`}
                aria-label="delete"
                onClick={() => {
                    setIsDeleteConfirmModalOpen(true);
                    setIdToDelete(idToRemind);
                }}
            >
                <DeleteOutlineOutlinedIcon />
            </IconButton>
        </Box>
    );
}
